import { createSelector } from 'reselect';
import { getCompany } from './getCompany';
import { getUser } from './getUser';

const getMandatoryCategorization = createSelector(
  [getCompany, getUser],
  (company, user) => {
    return company.mandatoryCategorization && !user.isRoot;
  }
);

export { getMandatoryCategorization };
